interface IParameters {
  apiKey: string;
  suggestApiKey: string;
  modules: string[];
}

export function loadYmapsApi({ apiKey, suggestApiKey, modules }: IParameters) {
  return new Promise((resolve, reject) => {
    /* istanbul ignore next */
    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const element = document.createElement('script');
    element.src = `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${apiKey}&suggest_apikey=${suggestApiKey}&lang=ru-RU&coordorder=longlat&load=${modules.join(
      ',',
    )}`;
    element.async = true;
    element.defer = true;
    element.onload = () => {
      window.ymaps.ready({
        /* istanbul ignore next */
        successCallback(ymaps: YMaps.IYMaps) {
          resolve(ymaps);
        },
        /* istanbul ignore next */
        errorCallback(error: Error) {
          reject(error);
        },
        require: [],
      });
    };
    element.onerror = () => {
      document.body.removeChild(element);
      reject(new Error('Unable to load Yandex Maps API'));
    };
    document.body.appendChild(element);
  });
}
